import { SkeletonWoo } from '@/components/skeleton/skeleton.woo';
import { type PinsProps } from '../-models/props';
import { WooEdit } from '@nosinovacao/fe-icons';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { Link } from '@tanstack/react-router';

export function PinsWoo({ loading, pins, id }: Readonly<PinsProps>) {
  const { t } = useI18n();
  return (
    <div className="grid gap-3">
      <SkeletonWoo className="h-[74px] rounded" count={3} loading={loading}>
        <div className="grid gap-3">
          {pins.map((p) => (
            <Link
              data-tid="link-edit-pin"
              to="/tv/$id/pins/$pin"
              params={{ pin: p.Type, id }}
              key={p.Type}
              className="grid grid-cols-[1fr_1.25rem] gap-x-2 rounded border border-nos-neutral-200 bg-nos-neutral-0 p-4"
            >
              <span
                data-tid="text-pin-type"
                className="font-light text-nos-neutral-500 font-text-p2"
              >
                {t(`Pins.Type.${p.Type}`)}
              </span>
              <div className="row-span-2 grid place-items-end">
                <WooEdit width={20} height={20} className="text-nos-neutral-500" />
              </div>
              <span data-tid="text-pin-code" className="font-bold text-nos-neutral-900 font-ui-8">
                {p.Code}
              </span>
            </Link>
          ))}
        </div>
      </SkeletonWoo>
    </div>
  );
}
